/* eslint-disable max-classes-per-file */
import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// @ts-ignore
import { SideNav } from 'react-sidenav';
import { connect } from 'react-redux';

import { SERVER_URL, FRONTEND_SERVER } from '../../config';
import PermissionComponent from './PermissionComponent';
import actions from '../../actions';
import { TClientData, THistory, TLocation, TUser } from '../../types';

class MenuHeader extends PermissionComponent {
    render() {
        return this.renderIfPerm(<h2>{this.props.children}</h2>);
    }
}

class MenuItem extends PermissionComponent {
    static contextTypes = {
        user: PropTypes.object,
        location: PropTypes.object,
    };

    render() {
        const { icon, badgeRender, href } = this.props;
        const groupClass = `navigation-menu-group${
            // @ts-ignore
            this.context.location.pathname
                .split('?')[0]
                .indexOf(this.props.href.split('?')[0]) > -1
                ? ' navigation-menu-group-selected'
                : ''
        }`;

        return this.renderIfPerm(
            href.startsWith(FRONTEND_SERVER) ||
                this.props.href.startsWith('/') ? (
                <Link // This is react link to http://local.development FRONTEND
                    to={href}
                    className={groupClass}
                    onClick={this.props.onClick}
                >
                    <i className={`icon ${icon}`} />
                    {this.props.children}
                    {badgeRender}
                </Link>
            ) : (
                <a // This is normal link to https://development BACKEND
                    href={href}
                    className={groupClass}
                    onClick={this.props.onClick}
                    target={this.props.target || '_self'}
                >
                    <i className={`icon ${icon}`} />
                    {this.props.children}
                    {badgeRender}
                </a>
            ),
        );
    }
}

type TUserProfileProps = {
    user: TUser;
};

type TUserProfileState = {
    collapsed: boolean;
};

class UserProfile extends Component<TUserProfileProps, TUserProfileState> {
    constructor(props: TUserProfileProps) {
        super(props);
        this.state = { collapsed: true };
        this.toggleCollapse = this.toggleCollapse.bind(this);
    }

    toggleCollapse() {
        this.setState(prevState => ({ collapsed: !prevState.collapsed }));
    }

    render() {
        let imageUrl = this.props?.user?.isAgent
            ? this.props?.user?.agency?.logo
            : this.props?.user?.client?.logo;
        if (!imageUrl) {
            imageUrl = 'static/images/default_profile.jpg';
        }
        const { email } = this.props.user;

        return (
            <div
                className={
                    !this.state.collapsed
                        ? 'expanded user-profile'
                        : 'user-profile'
                }
            >
                <div onClick={this.toggleCollapse}>
                    <div
                        className="avatar"
                        style={{ backgroundImage: `url(${imageUrl})` }}
                    />
                    <span title={email}>{email}</span>
                </div>
                <div>
                    {this.props.user.isClient && (
                        <MenuItem
                            icon="icon-person-edit-2"
                            href="/account/edit-profile"
                        >
                            Edit profile
                        </MenuItem>
                    )}
                    <MenuItem
                        icon="icon-key-1"
                        href="/account/change-password"
                    >
                        Edit password
                    </MenuItem>
                    <MenuItem
                        icon="icon-logout-2"
                        href={`${SERVER_URL}/account/logout/`}
                    >
                        Logout
                    </MenuItem>
                </div>
            </div>
        );
    }
}

type TNavigationBarProps = {
    clientData: TClientData
    notifications: any;
    user: TUser;
    location: TLocation;
    history: THistory;
    openNotifications: any;
    loadNotifications: any;
};

class NavigationBar extends Component<TNavigationBarProps> {
    static childContextTypes = {
        user: PropTypes.any,
        location: PropTypes.any,
    };

    getChildContext() {
        return { user: this.props.user, location: this.props.location }; // NOTICE: We create context here (Provider) that is used (Consumer) in MenuItem or MenuHeader
    }

    render() {
        const canApplyForCredit = this.props.user.isClient && this.props.clientData?.can_apply_for_credit;

        return (
            <div>
                <SideNav highlightColor="#fff">
                    {/* USER PROFILE */}
                    <UserProfile user={this.props.user} />

                    <MenuItem
                        icon="icon-email-2"
                        href="/notifications"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            this.props.openNotifications();
                            this.props.loadNotifications();
                            e.preventDefault();
                        }}
                        badgeRender={
                            <span>
                                {this.props?.notifications
                                    ?.total_unread_messages ? (
                                    <span className="badge">
                                        {
                                            this.props?.notifications
                                                ?.total_unread_messages
                                        }
                                    </span>
                                ) : (
                                    ''
                                )}
                            </span>
                        }
                    >
                        Notifications
                    </MenuItem>

                    {/* SHIFT MANAGEMENT */}
                    <MenuHeader requiredPermission="auth.manage_prejob_ops">
                        Shifts Management
                    </MenuHeader>
                    <MenuHeader
                        requiredRole="client"
                        requiredPermission="!auth.manage_prejob_ops"
                    >
                        Bookings
                    </MenuHeader>
                    {this.props.user.isAgent && (
                        <MenuItem
                            icon="icon-baggage-cart"
                            requiredPermission="auth.manage_prejob_ops"
                            href="/series/list/?is_cancelled=false"
                        >
                            Ongoing jobs
                        </MenuItem>
                    )}
                    <MenuItem
                        icon="icon-toolbox"
                        requiredPermission="auth.manage_prejob_ops"
                        href="/jobs/list"
                    >
                        Shifts management
                    </MenuItem>
                    <MenuItem
                        icon="icon-account-group-3"
                        requiredPermission="auth.manage_postjob_ops"
                        href="/clients"
                    >
                        {this.props.user.agency &&
                        this.props.user.agency.features.indexOf(
                            'external-clients',
                        ) > -1
                            ? 'Clients'
                            : 'Venues'}
                    </MenuItem>
                    <MenuItem
                        title="Create booking"
                        icon="icon-box-time"
                        requiredRole="client"
                        requiredPermission="!auth.manage_postjob_ops"
                        href="/job/create"
                    >
                        Create booking
                    </MenuItem>
                    <MenuItem
                        icon="icon-briefcase"
                        requiredRole="client"
                        requiredPermission="!auth.manage_prejob_ops"
                        href="/jobs/list"
                    >
                        My bookings
                    </MenuItem>
                    <MenuItem
                        icon="icon-check-circle"
                        requiredRole="client"
                        requiredPermission="!auth.manage_prejob_ops"
                        href="/jobs/timesheet-approval"
                    >
                        Timesheet approval
                    </MenuItem>
                    {canApplyForCredit && (
                        <MenuItem
                            icon="icon-email-2"
                            requiredRole="client"
                            requiredPermission="!auth.manage_postjob_ops"
                            href={this.props.clientData.apply_for_credit_url}
                            target="_blank"
                        >
                            Apply for Credit Account
                        </MenuItem>
                    )}

                    {/* SUPPLY */}
                    <MenuHeader requiredPermission="freelancer.add_freelancer">
                        Supply
                    </MenuHeader>
                    <MenuItem
                        icon="icon-phone-book-1"
                        requiredPermission="freelancer.add_freelancer"
                        href="/freelancers/?is_archived=false"
                    >
                        Workers
                    </MenuItem>

                    {this.props.user.isAgent && (
                        <>
                            <MenuItem
                                icon="icon-list-edit"
                                requiredPermission="freelancer.add_freelancer"
                                href="/availability-lists/?is_archived=false"
                            >
                                Availability lists
                            </MenuItem>
                            <MenuItem
                                icon="icon-waiting-room"
                                requiredPermission="freelancer.add_freelancer"
                                href="/waiting-room/?is_archived=false"
                            >
                                Waiting room
                            </MenuItem>
                        </>
                    )}

                    <MenuItem
                        icon="icon-box-full"
                        requiredPermission="freelancer.change_document"
                        href={`${SERVER_URL}/freelancer/admin/documents/`}
                    >
                        Documents review
                    </MenuItem>

                    <MenuItem
                        icon="icon-calendar-2"
                        requiredFeature="interviews"
                        requiredPermission="freelancer.add_inductionsession"
                        href="/induction-session-calendar/"
                    >
                        Induction sessions
                    </MenuItem>

                    <MenuItem
                        icon="icon-customer"
                        requiredFeature="interviews"
                        requiredPermission="freelancer.add_inductionsession"
                        href={`${SERVER_URL}/freelancer/admin/interviewees/`}
                    >
                        Onboarding pipeline
                    </MenuItem>

                    {/* OPERATIONS */}
                    <MenuHeader
                        requiredRole="agent"
                        requiredPermission="auth.manage_postjob_ops"
                    >
                        Operations
                    </MenuHeader>
                    <MenuItem
                        icon="icon-location-user"
                        requiredPermission="auth.manage_postjob_ops"
                        href="/operations/locationtracking"
                    >
                        Location tracking
                    </MenuItem>
                    <MenuItem
                        icon="icon-file-table2"
                        requiredPermission="auth.manage_postjob_ops"
                        href="/operations/bookings"
                    >
                        Bookings sheet
                    </MenuItem>
                    <MenuItem
                        icon="icon-bubble-chat-question-2"
                        requiredFeature="client_feedbacks"
                        requiredRole="client"
                        href="/operations/bookings/?bookings_status=FR&getall=1"
                    >
                        Feedbacks
                    </MenuItem>

                    {/* PAYMENTS */}
                    <MenuHeader
                        requiredFeature="external-clients"
                        requiredPermission="payment.add_transaction"
                    >
                        Payments
                    </MenuHeader>
                    <MenuItem
                        icon="icon-bank-2"
                        requiredPermission="auth.add_payroll"
                        href="/payments/payroll/"
                    >
                        Payroll
                    </MenuItem>
                    <MenuItem
                        icon="icon-file-table2"
                        requiredPermission="auth.view_timesheets_report_page"
                        href="/payments/payroll-admin/"
                    >
                        Payroll Admin
                    </MenuItem>

                    {/* SETTINGS */}
                    <MenuHeader requiredRole="agent" requiredPermission="staff">
                        Settings
                    </MenuHeader>
                    <MenuItem
                        icon="icon-cog"
                        requiredRole="agent"
                        requiredPermission="auth.change_settings"
                        href="/operations/settings"
                    >
                        System settings
                    </MenuItem>
                    <MenuItem
                        title="Django admin"
                        icon="icon-computer-bar-graph"
                        requiredPermission="staff"
                        href={`${SERVER_URL}/admin/`}
                    >
                        Django admin
                    </MenuItem>

                    {/* HELP */}
                    <MenuHeader requiredRole="agent">Help</MenuHeader>
                    <MenuItem
                        icon="icon-presentation-media"
                        requiredRole="agent"
                        href="/static/guide"
                    >
                        Training guide
                    </MenuItem>

                    {/* CONTACT */}
                    <MenuHeader requiredRole="client">Get in Touch</MenuHeader>
                    <MenuItem
                        icon="icon-mobile-phone-text-message-2"
                        requiredRole="client"
                        href="/contact-us"
                    >
                        Contact us
                    </MenuItem>
                </SideNav>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    if (state.tracking) {
        return {
            clientData: state.clientData?.basicInfo,
            notifications: state.notifications,
            user: state.user,
        };
    }
    return {
        user: { content: [] as any },
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    openNotifications: () => dispatch(actions.openNotifications()),
    loadNotifications: () => dispatch(actions.loadNotifications()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavigationBar) as any);
